import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnlyNumberDirective } from './only-number.directive';
import { OnlyDecimalDirective } from './only-decimal.directive';
import { PhoneMaskDirective } from './phone-mask.directive';
import { SwiperDirective } from './swiper.directive';
import { AutoFocusDirective } from './autofocus.directive';
import { BidAmountDirective } from './bidAmountDirective';
import { BidAmountInputDirective } from './bidAmountInputDirective';
import { TransformAmountDirective } from './transformAmountDirective';
import { TransformAmountIfNumberDirective } from './transformAmountIfNumberDirective';
import { TransformPercentDirective } from './transformPercentDirective';


@NgModule({
  declarations: [
    OnlyNumberDirective,
    OnlyDecimalDirective,
    PhoneMaskDirective,
    SwiperDirective,
    AutoFocusDirective,
    BidAmountDirective,
    BidAmountInputDirective,
    TransformAmountDirective,
    TransformAmountIfNumberDirective,
    TransformPercentDirective
  ],
  exports: [
    OnlyNumberDirective,
    OnlyDecimalDirective,
    PhoneMaskDirective,
    SwiperDirective,
    AutoFocusDirective,
    BidAmountDirective,
    BidAmountInputDirective,
    TransformAmountDirective,
    TransformAmountIfNumberDirective,
    TransformPercentDirective
  ],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
